// extracted by mini-css-extract-plugin
export default {"wrap":"Rp-z","logoContainer":"Sp-z","brandImg":"Tp-z","logoImg":"Up-z","logoButton":"Vp-z"};